<template>
  <div class="page-title">
    <h2>{{title}}</h2>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

h2 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline;
}

.text-white h2 {
  color: theme.$text-white;
  margin: 0;
}
</style>